export default "__VITE_ASSET__$39Dl_s6__"